import React from 'react';
export function TrustedBar() {
  return <div className="relative overflow-hidden bg-warm-gray border-y border-warm-border py-8" data-id="element-272">
      <p className="font-heading font-bold text-[14px] md:text-[16px] text-navy/70 uppercase tracking-[0.1em] text-center mb-6" data-id="element-273">
        Trusted by leaders and organizations across multiple countries
      </p>
      <div className="flex animate-marquee whitespace-nowrap" data-id="element-274">
        {[...Array(4)].map((_, setIndex) => <div key={setIndex} className="flex items-center shrink-0" data-id="element-275">
            <div className="flex items-center gap-3 mx-12" data-id="element-276">
              <img src="https://cdn.magicpatterns.com/uploads/x7RwcvEQTgnc6tntfForRr/Emirates_banner_logo.svg.png" alt="Emirates Airlines" className="h-10 w-auto object-contain" data-id="element-277" />
              <span className="font-heading font-medium text-[13px] text-charcoal/60 uppercase tracking-wide" data-id="element-278">
                Emirates Airlines
              </span>
            </div>
            <div className="w-[1px] h-6 bg-warm-border mx-6" data-id="element-279" />
            <div className="flex items-center gap-3 mx-12" data-id="element-280">
              <img src="https://cdn.magicpatterns.com/uploads/mRkYZJ9GNGWbuXbGAEPdzg/Hc_V_Logo.png" alt="Hope Channel" className="h-10 w-auto object-contain" data-id="element-281" />
              <span className="font-heading font-medium text-[13px] text-charcoal/60 uppercase tracking-wide" data-id="element-282">
                Hope Channel
              </span>
            </div>
            <div className="w-[1px] h-6 bg-warm-border mx-6" data-id="element-283" />
            <div className="flex items-center gap-3 mx-12" data-id="element-284">
              <img src="https://cdn.magicpatterns.com/uploads/x6d6YsUW7y5XT9eE9fpjTE/68ddb1037c961d4a77ac25a3_logo_copy.svg" alt="AXCS Capital" className="h-10 w-auto object-contain" data-id="element-285" />
              <span className="font-heading font-medium text-[13px] text-charcoal/60 uppercase tracking-wide" data-id="element-286">
                AXCS Capital
              </span>
            </div>
            <div className="w-[1px] h-6 bg-warm-border mx-6" data-id="element-287" />
            <div className="flex items-center gap-3 mx-12" data-id="element-288">
              <img src="https://cdn.magicpatterns.com/uploads/3Xtm6AoBUpmhCXU5ggmMsA/images.png" alt="George Smith Partners" className="h-10 w-auto object-contain" data-id="element-289" />
              <span className="font-heading font-medium text-[13px] text-charcoal/60 uppercase tracking-wide" data-id="element-290">
                George Smith Partners
              </span>
            </div>
            <div className="w-[1px] h-6 bg-warm-border mx-6" data-id="element-291" />
          </div>)}
      </div>
    </div>;
}